import CryptoJS from 'crypto-js';

export function encryptString(string) {
  const salt = CryptoJS.lib.WordArray.create(0); // empty array
  const params = CryptoJS.kdf.OpenSSL.execute(import.meta.env.VITE_CRYPTO_HASH, 256 / 32, 128 / 32, salt);
  const encrypted = CryptoJS.AES.encrypt(string, params.key, { iv: params.iv });

  return encrypted.ciphertext.toString();
}
